// note that these are the values used with the Zervant backend, but relevant values
// in e.g. TaxRate tags in billy-api will be written in lowercase, vide: TaxRuleProductType
export enum ProductType {
  Goods = 'GOODS',
  Services = 'SERVICES',
}
